<template>
  <el-dialog :destroy-on-close="true" :visible.sync="dialogVisible" width="25%" :before-close="close">
    <div slot="title" class="title">切换点位</div>
    <div>
      <el-form
        size="small"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
		<el-form-item label="新编号" prop="new_number">
			<el-input
			  size="small"
			  clearable
			  placeholder="请输入新编号"
			  v-model="ruleForm.new_number"
			></el-input>
		</el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="small-btn btn-bor" size="small" @click="close"
        >取 消</el-button
      >
      <el-button
        class="small-btn bgC"
        size="small"
        type="primary"
        @click="submitForm('ruleForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
	  disabled: {
	    type: Boolean,
	    default() {
	      return false;
	    },
	  },
	
	accountObj:{
		type:Object,
		default(){
			return {}
		}
	}
  },
  data() {
    return {
      dialogVisible: false,
	  refuse:false,
      ruleForm: {
	    new_number: '',
      },
      rules: {
        new_number: [{ required: true, message: "请输入新编号", trigger: "blur" }],
      },
    };
  },
  methods: {
	  onRadio(){
		this.refuse = this.ruleForm.status == 2?true:false;
	  },
    //   提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
			this.$emit('onPoint',this.ruleForm)
        } else {
          this.$message.error("请输入必填项！");
          return false;
        }
      });
    },
    //   关闭弹框
    close() {
      this.dialogVisible = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style>
.title {
  text-align: left;
}
.el-form-item__label {
  padding: 0 !important;
}
.el-form-item {
  margin-bottom: 0 !important;
  padding: 5px 30px;
}
.el-dialog__body {
  padding-top: 10px;
}
.el-dialog {
  border-radius: 8px;
}
.el-dialog__footer {
  padding-top: 0;
  text-align: center;
}
.small-btn:hover {
  opacity: 0.8 !important;
}
.small-btn:active {
  opacity: 0.9 !important;
}
</style>